// Logout API for public user
import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL || "/api";
const API = axios.create({ baseURL: API_BASE_URL });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const logoutPublicUser = async (email) => {
  return await API.post("/publicuser/logout", { email });
};
